import { BuilderAnimationDelta } from './builderAnimationDelta';

export class BuilderAnimationFrame {
    public deltas: BuilderAnimationDelta[] = [];

    /**
     * Duration in ms.
     */
    public duration = 100;
}
